import { useEffect } from 'react';
import { useTraitsActions } from '@atlassian/jira-traits/src/TraitsStore.tsx';
import { useCloudId } from '@atlassian/jira-tenant-context-controller/src/components/cloud-id/index.tsx';
import { useAccountId } from '@atlassian/jira-tenant-context-controller/src/components/account-id/index.tsx';
import { SITE_USER } from '@atlassian/jira-traits/src/constants.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { useIsJiraUserFirstActiveWithinXDaysTraitSelector } from './useIsJiraUserFirstActiveWithinXDaysTraitSelector.tsx';

export const useIsJiraUserFirstActiveWithinXDays = (xDays: number) => {
	const cloudId = useCloudId();
	const accountId = useAccountId();
	const { fetchTraits } = useTraitsActions();
	useEffect(() => {
		if (!fg('jira_ybr_precondition_check_rollout_cross_flow')) {
			return;
		}

		fetchTraits([SITE_USER], { cloudId, accountId });
	}, [cloudId, accountId, fetchTraits]);
	return useIsJiraUserFirstActiveWithinXDaysTraitSelector(xDays);
};
